import React, { Suspense } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

/**
 * UserTestingLayout — sub-layout for User Testing nested routes.
 *
 * After the AeroLayout refactor, all auth, subscription fetching, sidebar
 * rendering, and GlassProvider setup live in AeroLayout. This component's
 * only job is to receive the outlet context from AeroLayout and relay it
 * to its own children (UserTestingDashboard, UserTestingProject, etc.).
 *
 * Route tree:
 *   AeroLayout → <Outlet> → UserTestingLayout → <Outlet> → UTDashboard / UTProject / …
 *
 * The nested <Suspense> here means that when a deep sub-route (UserTestingProject,
 * UTOverviewTab, etc.) lazy-loads for the first time, only the content area shows
 * a skeleton — the sidebar and AeroLayout shell are unaffected. Without this
 * boundary, the top-level Suspense in App.js would fire and replace the entire
 * screen (sidebar included) with UserTestingSkeleton.
 */

function UTProjectFallback() {
  return (
    <div className="ut-dashboard">
      <div className="ut-dashboard-header">
        <div className="ut-skeleton" style={{ width: 200, height: 28 }} />
      </div>
      <div className="ut-skeleton ut-skeleton-card" style={{ height: 240, marginBottom: 16 }} />
      <div className="ut-skeleton ut-skeleton-card" style={{ height: 120 }} />
    </div>
  );
}

function UserTestingLayout() {
  const context = useOutletContext();
  return (
    <Suspense fallback={<UTProjectFallback />}>
      <Outlet context={context} />
    </Suspense>
  );
}

export default UserTestingLayout;
